import { render, staticRenderFns } from "./phdp-index-1.vue?vue&type=template&id=fc656c04&scoped=true"
import script from "./phdp-index-1.vue?vue&type=script&lang=js"
export * from "./phdp-index-1.vue?vue&type=script&lang=js"
import style0 from "./phdp-index-1.vue?vue&type=style&index=0&id=fc656c04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc656c04",
  null
  
)

export default component.exports